import { Component } from 'react';
import Card from './card';
import Popup from './planCardPopup';
import { Router } from '../../configs/routes';
import { handleTrack } from '../../utils/trackActions';

interface Props {
  data?: any;
  id: string;
  hideHighlights: boolean;
  hideBenifits: boolean;
  hideSpacer: boolean;
  minHeight: boolean;
  url?: any;
}

interface State {
  popupOpen: boolean;
}

class PlanCardContainer extends Component<Props, State> {
  public state: State = {
    popupOpen: false,
  };

  public investClick = () => {
    this.hidePopup();
  };

  public showPopup = (e: any) => {
    const { bucketId, title } = this.props.data;
    const { id } = this.props;
    const path = `/save/plan/${bucketId}`;
    Router.pushRoute(path);
    handleTrack({
      label: `card_${id}_${title}`,
      obj: e.target,
      url: path,
    });
  };

  public hidePopup = () => {
    this.setState({ popupOpen: false });
    document.querySelectorAll('body, html').forEach(el => {
      el.style.overflow = 'auto';
    });
  };

  public render() {
    const { data } = this.props;
    return (
      <div>
        <Card data={data} handleClick={this.showPopup} {...this.props} />
        <Popup
          hidePopup={this.hidePopup}
          data={data}
          show={this.state.popupOpen}
          investClick={this.investClick}
        />
      </div>
    );
  }
}

export default PlanCardContainer;



// WEBPACK FOOTER //
// ./components/homePage/planCardContainer.tsx